import { queryClient } from 'App';

// Terminal import status pushed from the backend Astro-webhook handlers
// (kind 'ehr-import-status' | 'csv-import-status'). We don't trust the pushed
// payload as the source of truth — we invalidate the status/list queries so the
// overview refetches the authoritative counts (summary.json / metadata). This is
// what lets us drop the old refetchInterval polling.
export default (data) => {
  const { kind, importInfoId, importId } = data || {};

  if (kind === 'ehr-import-status' && importInfoId !== undefined && importInfoId !== null) {
    queryClient.invalidateQueries(['ehr-import-status', importInfoId]);
  }

  // Both flows surface in the metadata list and the per-import detail view.
  queryClient.invalidateQueries(['import-metadata']);
  if (importId !== undefined && importId !== null) {
    queryClient.invalidateQueries(['import-detail', importId]);
  }
};
